import "./utils/fetch_monitor.js";
import { showToastMessage } from './utils/toast_message.js';
import { updateCharacterCollect } from "./utils/collect_character";
import { logFrontendError } from "./utils/log_error";
import { setCardQuantities } from "./utils/display_user_card_quantities";
import { initCardList } from "./utils/card_list/card_list.js";
import { loadCardTraders } from "./utils/card_traders.js";
import { handleFetchError } from "./utils/fetch_utils.js";
import { loadUserNotifications } from "./utils/notifications.js";
import { initHelpPopovers } from "./utils/help_popovers.js";

window.showToastMessage = showToastMessage;
const saveTimers = new Map();
let notificationMenu;

document.addEventListener('DOMContentLoaded', function() {
    initializeCharacterPage();
})

async function initializeCharacterPage(){
    window.configAlertTimeout = document.getElementById('window-alert-timeout').dataset.alertTimeout;
    const charInfoDiv = document.getElementById('char-info-results');
    const charCardsDiv = document.getElementById('char-cards-results');
    const charInfoSpinner = document.getElementById('char-info-loading-spinner');
    const charCardsSpinner = document.getElementById('char-cards-loading-spinner');
    const dataDiv = document.getElementById('data-div');
    const charNameEl = document.getElementById('char-name');
    const charId = dataDiv.dataset.characterId;
    notificationMenu = document.getElementById('notification-menu');

    charInfoDiv.addEventListener('click', (event) => {
        const button = event.target.closest('.collect-toggle');

        if (!button) {
            return;
        }
        updateCharacterCollect(button, charId, charNameEl.textContent);
    });
    const collectMode = dataDiv.dataset.userCollectMode;
    loadUserNotifications(notificationMenu);
    // the explore page has no signed-in user, so its list has no marks to edit and no tracked cards to show
    const isPublic = dataDiv.dataset.isPublic === 'true';
    const cardsUrl = isPublic
        ? `/api/character/${charId}/cards?is_public=1`
        : `/api/character/${charId}/cards?collect_mode=${collectMode}`;
    const cardsPromise = fetch(cardsUrl).then(r => { if(!r.ok){ throw new Error('Error getting card data.')} return r.text()});
    const userPromise = isPublic
        ? Promise.resolve(null)
        : fetch(`/api/current_user/tracked_cards`).then(r => { if(!r.ok){ throw new Error(`Error getting user's cards.`)} return r.json()});

    charInfoSpinner.classList.remove('d-none');
    charCardsSpinner.classList.remove('d-none');

    fetch(`/character/${charId}/info`)
    .then(response => {
        if (!response.ok){
            throw new Error("Error getting character info");
        }
        return response.json();
    })
    .then(data => {
        charInfoDiv.innerHTML = data.html;
        charNameEl.textContent = data.name;
    })
    .catch(handleFetchError)
    .finally(() => {
        charInfoSpinner.classList.add('d-none');
    });

    const [cardsResults, userResults] = await Promise.allSettled([
        cardsPromise, userPromise
    ]);
    let cardList;
    if (cardsResults.status === "fulfilled") {
        charCardsDiv.innerHTML = cardsResults.value;
        cardList = initCardList(charCardsDiv.querySelector('[data-card-list]'), { saveTimers, isPublic });
        initHelpPopovers(charCardsDiv);
        charCardsSpinner.classList.add('d-none');
    }
    else {
        charCardsSpinner.classList.add('d-none');
        showToastMessage(cardsResults.reason.message, "danger");
        logFrontendError(cardsResults.reason.message);
        return;
    }
    if(isPublic){
        return;
    }
    if(userResults.status === "fulfilled"){
        userResults.value.tracked_cards.forEach(tc => {
            setCardQuantities(tc);
        });
        cardList.refresh();
        loadCardTraders(charCardsDiv);
    }
    else {
        showToastMessage(userResults.reason.message, "danger");
        logFrontendError(userResults.reason.message);
    }
}
